import { render, staticRenderFns } from "./MenuPage.vue?vue&type=template&id=89162c9a&scoped=true&"
import script from "./MenuPage.vue?vue&type=script&lang=ts&"
export * from "./MenuPage.vue?vue&type=script&lang=ts&"
import style0 from "./MenuPage.vue?vue&type=style&index=0&id=89162c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89162c9a",
  null
  
)

export default component.exports